export default __webpack_public_path__ + "static/media/ajax-icon.0f782d07.svg";